import Avatar from 'boring-avatars-svg';
import { seededRandom } from './seeded-random';

const anonymousUserSvgPart = `<path fill-rule="evenodd" clip-rule="evenodd" d="M40.019 21.4434C45.5041 21.4434 49.9858 25.9251 49.9858 31.4102C49.9858 36.8953 45.5041 41.377 40.019 41.377C34.5339 41.377 30.0522 36.8953 30.0522 31.4102C30.0522 25.9251 34.5339 21.4434 40.019 21.4434ZM25.0166 55.5043C20.0633 50.2257 25.0166 46.3453 31.4305 46.3453H48.1643C55.0221 46.3453 59.9099 50.2243 55.0221 55.5043C51.0406 59.0818 45.7896 61.2745 40.0193 61.2745C34.2491 61.2745 28.9981 59.0818 25.0166 55.5043Z" fill="white"/>`;

const colorPalettes = [
  ['#69d2e7', '#a7dbd8', '#e0e4cc', '#f38630', '#fa6900'],
  ['#fe4365', '#fc9d9a', '#f9cdad', '#c8c8a9', '#83af9b'],
  ['#ecd078', '#d95b43', '#c02942', '#542437', '#53777a'],
  ['#556270', '#4ecdc4', '#c7f464', '#ff6b6b', '#c44d58'],
  ['#e8ddcb', '#cdb380', '#036564', '#033649', '#031634'],
  ['#490a3d', '#bd1550', '#e97f02', '#f8ca00', '#8a9b0f'],
  ['#594f4f', '#547980', '#45ada8', '#9de0ad', '#e5fcc2'],
  ['#00a0b0', '#6a4a3c', '#cc333f', '#eb6841', '#edc951'],
  ['#e94e77', '#d68189', '#c6a49a', '#c6e5d9', '#f4ead5'],
  ['#413e4a', '#73626e', '#b38184', '#f0b49e', '#f7e4be'],
  ['#ff4e50', '#fc913a', '#f9d423', '#ede574', '#e1f5c4'],
  ['#99b898', '#fecea8', '#ff847c', '#e84a5f', '#2a363b'],
  ['#655643', '#80bca3', '#f6f7bd', '#e6ac27', '#bf4d28'],
  ['#351330', '#424254', '#64908a', '#e8caa4', '#cc2a41'],
  ['#554236', '#f77825', '#d3ce3d', '#f1efa5', '#60b99a'],
  ['#5d4157', '#838689', '#a8caba', '#cad7b2', '#ebe3aa'],
  ['#8c2318', '#5e8c6a', '#88a65e', '#bfb35a', '#f2c45a'],
  ['#fad089', '#ff9c5b', '#f5634a', '#ed303c', '#3b8183'],
  ['#f8b195', '#f67280', '#c06c84', '#6c5b7b', '#355c7d'],
  ['#5e412f', '#fcebb6', '#78c0a8', '#f07818', '#f0a830'],
  ['#bcbdac', '#cfbe27', '#f27435', '#f02475', '#3b2d38'],
  ['#452632', '#91204d', '#e4844a', '#e8bf56', '#e2f7ce'],
  ['#f0d8a8', '#3d1c00', '#86b8b1', '#f2d694', '#fa2a00'],
  ['#2a044a', '#0b2e59', '#0d6759', '#7ab317', '#a0c55f'],
  ['#bbbb88', '#ccc68d', '#eedd99', '#eec290', '#eeaa88'],
  ['#b3cc57', '#ecf081', '#ffbe40', '#ef746f', '#ab3e5b'],
  ['#a3a948', '#edb92e', '#f85931', '#ce1836', '#009989'],
  ['#300030', '#480048', '#601848', '#c04848', '#f07241'],
  ['#67917a', '#170409', '#b8af03', '#ccbf82', '#e33258'],
  ['#e8d5b7', '#0e2430', '#fc3a51', '#f5b349', '#e8d5b9'],
  ['#ab526b', '#bca297', '#c5ceae', '#f0e2a4', '#f4ebc3'],
  ['#607848', '#789048', '#c0d860', '#f0f0d8', '#604848'],
  ['#a8e6ce', '#dcedc2', '#ffd3b5', '#ffaaa6', '#ff8c94'],
  ['#3e4147', '#fffedf', '#dfba69', '#5a2e2e', '#2a2c31'],
  ['#fc354c', '#29221f', '#13747d', '#0abfbc', '#fcf7c5'],
  ['#cc0c39', '#e6781e', '#c8cf02', '#f8fcc1', '#1693a7'],
  ['#1c2130', '#028f76', '#b3e099', '#ffeaad', '#d14334'],
  ['#a7c5bd', '#e5ddcb', '#eb7b59', '#cf4647', '#524656'],
  ['#dad6ca', '#1bb0ce', '#4f8699', '#6a5e72', '#563444'],
  ['#5c323e', '#a82743', '#e15e32', '#c0d23e', '#e5f04c'],
  ['#edebe6', '#d6e1c7', '#94c7b6', '#403b33', '#d3643b'],
  ['#fdf1cc', '#c6d6b8', '#987f69', '#e3ad40', '#fcd036'],
  ['#b9d3b0', '#81bda4', '#b28774', '#f88f79', '#f6aa93'],
  ['#3a111c', '#574951', '#83988e', '#bcdea5', '#e6f9bc'],
  ['#e3dfba', '#c8d6bf', '#93ccc6', '#6cbdb5', '#1a1f1e'],
  ['#a1dbb2', '#fee5ad', '#faca66', '#f7a541', '#f45d4c'],
  ['#5e9fa3', '#dcd1b4', '#fab87f', '#f87e7b', '#b05574'],
  ['#951f2b', '#f5f4d7', '#e0dfb1', '#a5a36c', '#535233'],
  ['#8dccad', '#988864', '#fea6a2', '#f9d6ac', '#ffe9af'],
  ['#2d2d29', '#215a6d', '#3ca2a2', '#92c7a3', '#dfece6'],
  ['#eff3cd', '#b2d5ba', '#61ada0', '#248f8d', '#605063'],
  ['#cfffdd', '#b4dec1', '#5c5863', '#a85163', '#ff1f4c'],
  ['#9dc9ac', '#fffec7', '#f56218', '#ff9d2e', '#919167'],
  ['#4e395d', '#827085', '#8ebe94', '#ccfc8e', '#dc5b3e'],
  ['#a8a7a7', '#cc527a', '#e8175d', '#474747', '#363636'],
  ['#f8edd1', '#d88a8a', '#474843', '#9d9d93', '#c5cfc6'],
  ['#046d8b', '#309292', '#2fb8ac', '#93a42a', '#ecbe13'],
  ['#f38a8a', '#55443d', '#a0cab5', '#cde9ca', '#f1edd0'],
  ['#a70267', '#f10c49', '#fb6b41', '#f6d86b', '#339194'],
  ['#ff003c', '#ff8a00', '#fabe28', '#88c100', '#00c176'],
  ['#ffedbf', '#f7803c', '#f54828', '#2e0d23', '#f8e4c1'],
  ['#4e4d4a', '#353432', '#94ba65', '#2790b0', '#2b4e72'],
  ['#fffbb7', '#a6f6af', '#66b6ab', '#5b7c8d', '#4f2958'],
  ['#edf6ee', '#d1c089', '#b3204d', '#412e28', '#151101'],
  ['#9d7e79', '#ccac95', '#9a947c', '#748b83', '#5b756c'],
  ['#9cddc8', '#bfd8ad', '#ddd9ab', '#f7af63', '#633d2e'],
  ['#d1313d', '#e5625c', '#f9bf76', '#8eb2c5', '#615375'],
  ['#ffe181', '#eee9e5', '#fad3b2', '#ffba7f', '#ff9c97'],
  ['#73c8a9', '#dee1b6', '#e1b866', '#bd5532', '#373b44'],
  ['#379f7a', '#78ae62', '#bbb749', '#e0fbac', '#1f1c0d'],
  ['#caff42', '#ebf7f8', '#d0e0eb', '#88abc2', '#49708a'],
  ['#7e5686', '#a5aad9', '#e8f9a2', '#f8a13f', '#ba3c3d'],
  ['#395a4f', '#432330', '#853c43', '#f25c5e', '#ffa566'],
  ['#fde6bd', '#a1c5ab', '#f4dd51', '#d11e48', '#632f53'],
  ['#84b295', '#eccf8d', '#bb8138', '#ac2005', '#2c1507'],
  ['#058789', '#503d2e', '#d54b1a', '#e3a72f', '#f0ecc9'],
  ['#6da67a', '#77b885', '#86c28b', '#859987', '#4a4857'],
  ['#bed6c7', '#adc0b4', '#8a7e66', '#a79b83', '#bbb2a1'],
  ['#efd9b4', '#d6a692', '#a39081', '#4d6160', '#292522'],
  ['#f2e3c6', '#ffc6a5', '#e6324b', '#2b2b2b', '#353634'],
  ['#c75233', '#c78933', '#d6ceaa', '#79b5ac', '#5e2f46'],
  ['#793a57', '#4d3339', '#8c873e', '#d1c5a5', '#a38a5f'],
  ['#512b52', '#635274', '#7bb0a8', '#a7dbab', '#e4f5b1'],
  ['#11644d', '#a0b046', '#f2c94e', '#f78145', '#f24e4e'],
  ['#59b390', '#f0ddaa', '#e47c5d', '#e32d40', '#152b3c'],
  ['#fdffd9', '#fff0b8', '#ffd6a3', '#faad8e', '#142f30'],
  ['#b5ac01', '#ecba09', '#e86e1c', '#d41e45', '#1b1521'],
  ['#c7fcd7', '#d9d5a7', '#d9ab91', '#e6867a', '#ed4a6a'],
  ['#11766d', '#410936', '#a40b54', '#e46f0a', '#f0b300'],
  ['#595643', '#4e6b66', '#ed834e', '#ebcc6e', '#ebe1c5'],
  ['#bf496a', '#b39c82', '#b8c99d', '#f0d399', '#595151'],
  ['#b7cbbf', '#8c886f', '#f9a799', '#f4bfad', '#f5dabd'],
  ['#e5eaa4', '#a8c4a2', '#69a5a4', '#616382', '#66245b'],
  ['#b1e6d1', '#77b1a9', '#3d7b80', '#270a33', '#451a3e'],
  ['#e4ded0', '#abccbd', '#7dbeb8', '#181619', '#e32f21'],
  ['#e9e0d1', '#91a398', '#33605a', '#070001', '#68462b'],
  ['#ffab07', '#e9d558', '#72ad75', '#0e8d94', '#434d53'],
  ['#6da67a', '#99a66d', '#a9bd68', '#b5cc6a', '#c0de5d'],
  ['#311d39', '#67434f', '#9b8e7e', '#c3ccaf', '#a51a41'],
  ['#cfb590', '#9e9a41', '#758918', '#564334', '#49281f'],
  ['#5cacc4', '#8cd19d', '#cee879', '#fcb653', '#ff5254'],
];

const getRandomColorPalette = (seed: string) => {
  const index = Math.floor(seededRandom(seed) * colorPalettes.length);
  return colorPalettes[index];
};

const guestAvatarSize = 196;

export const jobTitles = [
  'Researcher',
  'Astronaut',
  'Specialist',
  'Associate',
  'Sightseer',
  'Contributor',
  'Librarian',
  'Architect',
  'Harvester',
  'Cartographer',
  'Whisperer',
  'Navigator',
  'Engraver',
  'Forecaster',
  'Tourist',
  'Weaver',
  'Magician',
  'Ranger',
  'Herbalist',
  'Bladesmith',
  'Rockstar',
  'Connoisseur',
  'Constructor',
  'Projectionist',
  'Merchant',
  'Ninja',
  'Auditor',
  'Biologist',
  'Advocate',
  'Evaluator',
  'Locator',
  'Alchemist',
  'Analyst',
  'Technician',
  'Scout',
  'Sherpa',
  'Engineer',
  'Guru',
  'Executive',
  'Hero',
  'Manager',
  'Disruptor',
];

export const calcInitials = (firstName: string, lastName: string, email: string) => {
  if (!firstName && !lastName) {
    if (email) return email[0];
    return 'U';
  }
  if (lastName) return firstName[0] + lastName[0];
  return firstName[0] + (firstName[1] || '');
};

export const getDefaultUserAvatar = (seed: string, initials: string) => {
  const svg = Avatar({
    variant: 'marble',
    colors: getRandomColorPalette(seed),
    name: seed,
    square: false,
    size: guestAvatarSize,
  });

  const combinedSvg = svg
    .replace(/<title>.*<\/title>/, '')
    .replace(
      '</g>',
      `<text x="50%" y="50%" dominant-baseline="middle" alignment-baseline="central" text-anchor="middle" fill="white" style="font-family: AkkuratLL; font-size: 32px; font-weight: normal">${initials.toUpperCase()}</text></g>`
    );
  return combinedSvg;
};

export const getAnonymousGuestAvatar = (seed: string) => {
  const svg = Avatar({
    variant: 'marble',
    colors: getRandomColorPalette(seed),
    name: seed,
    square: false,
    size: guestAvatarSize,
  });
  const combinedSvg = svg.replace(/<title>.*<\/title>/, '').replace('</g>', `${anonymousUserSvgPart}</g>`);
  return combinedSvg;
};
